import {
  ArchiveIcon,
  AwardIcon,
  BabyIcon,
  BicepsFlexedIcon,
  BookImageIcon,
  BookMarkedIcon,
  BookOpenIcon,
  BuildingIcon,
  BusIcon,
  CakeIcon,
  CalculatorIcon,
  CalendarClockIcon,
  CalendarIcon,
  CarIcon,
  ClockIcon,
  CoffeeIcon,
  CreditCardIcon,
  CupSodaIcon,
  DatabaseIcon,
  FactoryIcon,
  FileTextIcon,
  FilmIcon,
  GiftIcon,
  GlobeIcon,
  GraduationCapIcon,
  HandCoinsIcon,
  HandshakeIcon,
  HeartIcon,
  HospitalIcon,
  LaptopIcon,
  MegaphoneIcon,
  MusicIcon,
  NewspaperIcon,
  PiggyBankIcon,
  StarIcon,
  TicketIcon,
  TreePalmIcon,
  TrophyIcon,
  TruckIcon,
  UserIcon,
  UtensilsIcon,
} from '@fukuri-admins/ui/common';

export const OPTION_GROUPS = [
  {
    title: '時間・スケジュール',
    items: [
      { value: 'calendar', label: 'カレンダー', Icon: CalendarIcon },
      { value: 'vacation', label: '休暇', Icon: TreePalmIcon },
      { value: 'event', label: 'イベント', Icon: CalendarClockIcon },
      { value: 'clock', label: '時計', Icon: ClockIcon },
    ],
  },
  {
    title: '人物・ソーシャル',
    items: [
      { value: 'member', label: 'メンバー', Icon: UserIcon },
      { value: 'baby', label: '赤ちゃん', Icon: BabyIcon },
      { value: 'heart', label: 'ハート', Icon: HeartIcon },
      { value: 'star', label: '星', Icon: StarIcon },
    ],
  },
  {
    title: '場所・移動',
    items: [
      { value: 'car', label: '車', Icon: CarIcon },
      { value: 'truck', label: 'トラック', Icon: TruckIcon },
      { value: 'bus', label: 'バス', Icon: BusIcon },
      { value: 'office', label: 'オフィス', Icon: BuildingIcon },
      { value: 'factory', label: '工場', Icon: FactoryIcon },
      { value: 'hospital', label: '病院', Icon: HospitalIcon },
    ],
  },
  {
    title: 'ツール',
    items: [
      { value: 'calculator', label: '計算機', Icon: CalculatorIcon },
      { value: 'newspaper', label: '新聞', Icon: NewspaperIcon },
      { value: 'learning', label: '学習', Icon: GraduationCapIcon },
      { value: 'megaphone', label: 'メガホン', Icon: MegaphoneIcon },
    ],
  },
  {
    title: 'テクノロジー・デバイス',
    items: [
      { value: 'computer', label: 'パソコン', Icon: LaptopIcon },
      { value: 'browser', label: 'ブラウザ', Icon: GlobeIcon },
      { value: 'photo', label: '写真', Icon: BookImageIcon },
      { value: 'album', label: 'アルバム', Icon: BookMarkedIcon },
    ],
  },
  {
    title: 'ドキュメント・メディア',
    items: [
      { value: 'document', label: '書類', Icon: FileTextIcon },
      { value: 'database', label: 'データベース', Icon: DatabaseIcon },
      { value: 'storage', label: '保管所', Icon: ArchiveIcon },
    ],
  },
  {
    title: 'Eコマース・お金',
    items: [
      { value: 'card', label: 'カード', Icon: CreditCardIcon },
      { value: 'coin', label: 'コイン', Icon: HandCoinsIcon },
      { value: 'ticket', label: 'チケット', Icon: TicketIcon },
      { value: 'savings', label: '貯金', Icon: PiggyBankIcon },
    ],
  },
  {
    title: '食事・食品',
    items: [
      { value: 'meal', label: '食事', Icon: UtensilsIcon },
      { value: 'cake', label: 'ケーキ', Icon: CakeIcon },
      { value: 'coffee', label: 'コーヒー', Icon: CoffeeIcon },
      { value: 'drink', label: '飲み物', Icon: CupSodaIcon },
    ],
  },
  {
    title: '趣味・エンタメ',
    items: [
      { value: 'movie', label: '映画', Icon: FilmIcon },
      { value: 'music', label: '音楽', Icon: MusicIcon },
      { value: 'fitness', label: 'フィットネス', Icon: BicepsFlexedIcon },
      { value: 'book', label: '本', Icon: BookOpenIcon },
    ],
  },
  {
    title: '表彰',
    items: [
      { value: 'badge', label: 'バッジ', Icon: AwardIcon },
      { value: 'trophy', label: 'トロフィー', Icon: TrophyIcon },
      { value: 'handshake', label: '握手', Icon: HandshakeIcon },
      { value: 'gift', label: 'ギフト', Icon: GiftIcon },
    ],
  },
];
